module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sorts":["Best in price bracket","Best","Best Value"],"fillProsCons":"Fill Pros and Cons","noLaptops":"No laptops found","title":"Laptops","under":"Under {0}"}}')
  delete Component.options._Ctor
}
